/* eslint-disable react-hooks/exhaustive-deps */
import '../../../../scss/components/_icons.scss';

import {
    Button,
    LoadingOverlay,
    Status,
    TextField,
} from '@finpay-development/shared-components';

import { PendingOutlined } from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import EditIcon from '@mui/icons-material/Edit';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LockIcon from '@mui/icons-material/Lock';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import {
    Box,
    Grid,
    IconButton,
    MenuItem,
    Paper,
    Typography,
} from '@mui/material';

import { Form, Formik } from 'formik';

import Cookies from 'js-cookie';

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import Comments
    from '../../../../implementation-specialist/components/implementation-clients/details/comments';
import LockModal
    from '../../../../implementation-specialist/components/locks/lock-modal';
import AccessControl from '../../../../security/components/access-control';
import { RolePageNames } from '../../../../security/model/role-page-names';
import { formatNumberToUSD } from '../../../../shared/calculators';
import CustomizeableAccordion
    from '../../../../shared/components/customizeable-accordion';
import HeaderWithDetails
    from '../../../../shared/components/header-with-details';
import { configSettings } from '../../../../shared/configuration/config-settings';
import {
    commentsPage,
    LoginVerifiedStatus,
    RecentlyViewedTypes,
    StatusColors,
} from '../../../../shared/enums';
import {
    RecentlyViewedUser,
    UsersCookiesList,
} from '../../../../shared/model/recentlyViewed';
import { RootState } from '../../../../shared/state/root-reducer';
import { AppDispatch } from '../../../../shared/state/store';
import { Utils } from '../../../../shared/utils';

import { patientService } from '../../../services/patient-service';
import { paynowService } from '../../../../guest/services/paynow-service';
import { userService } from 'src/admin/services/admin-user-service';
import {
    admissionsAdvisorService,
} from '../../../../admissions-advisor/services/admissions-advisor-services';
import {
    configGetPayers,
} from '../../../../admin-configuration/state/admin-configuration-thunk';
import { admissionsAdvisorUtils } from 'src/admissions-advisor/utils/admission-advisor-utils';

import { showErrorStatus } from 'src/security/state/user-slice';
import {
    resetPatientRecordLockingContext,
    setInUseModalOpen_overview,
    setIsIOCModalOpen,
    setLockRequestedById,
    setLockStatusReleased_overview,
    setRequestDeniedModalOpen_overview,
} from '../../../state/patient-record-locking-slice';
import { getVOBForPatientRecords } from '../../../../admissions-advisor/state/vob-thunk';
import { initializePatientVOBState, setVobAndEstimate } from '../../../../admissions-advisor/state/vob-slice';
import {
    denyRequestOk,
    editModalPoll,
    releaseRecordOk,
    requestReleaseOk,
} from '../../../state/patient-record-locking-thunk';
import {
    clearReleaseChargeError,
    resetPatientContext,
    setAccountHolderContext,
    setRecentlyViewedPatients,
    setSelectedEncounter,
    setLedgerData,
} from '../../../state/patient-slice';
import {
    getDocuments,
    getInstanceOfCare,
    getPatientDocuments,
    getPatientNotes,
    getPaymentMethods,
    getS3Document,
    lockIOC,
    setRecentlyViewedPatient,
    updateIOC,
    updateWarmTransfer,
} from '../../../state/patient-thunk';
import {
    getFinancialStatusColor,
    getPatientStatusByStatusId,
    StatusType,
} from '../../misc/patient-status';
import {
    BalanceAdjustment,
    emptyBalanceAdjustment,
} from '../../models/balance-adjustment';
import { LockablePatientRecordSection } from '../../models/lockable-patient-record-section';
import {
    emptyPatientEncounter,
    PatientEncounter,
} from '../../models/patient-encounter';
import { SignatureStatus } from '../../models/signature-tracking';
import { DocumentsAccordionContents } from '../documents/documents-accordion-contents';
import DocumentsStatusAccordion from '../documents/documents-status-accordion';
import InsuranceAccordionContents from '../insurance/insurance-accordion-contents';
import { InsuranceModal } from '../insurance/insurance-modal';
import ChampionAccordionContents from '../patient champion/champion-accordion-contents';
import { ChampionModal } from '../patient champion/patient-champion-modal';
import PaymentProgramAccordionContents from '../payment-programs/payment-program-accordion-contents';
import { PaymentProgramsModal } from '../payment-programs/payment-programs-modal';
import { PaymentProgramsV2Modal } from '../payment-programs-v2/payment-programs-v2-modal';
import BalanceAdjustmentConfirmationModal from '../payment-status/balance-adjustment/balance-adjustment-confirmation-modal';
import { BalanceAdjustmentModal } from '../payment-status/balance-adjustment/balance-adjustment-modal';
import { PaymentStatusAccordionContents } from '../payment-status/payment-status-accordion-contents';
import { ProgramStatusAccordionContents } from '../payment-status/program-status-accordion-contents';
import { InstanceOfCareModal } from './instance-of-care-modal';

import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import AccountStatusAccordian from '../account/account-status-accordian';
import { PrimaryContact } from 'src/shared/model/primary-contact';
import { ClientStatusCardViewModel } from 'src/shared/model/client-status-card';
import { PatientChampion } from '../../models/patient-champion';
import _ from 'lodash/fp';
import { Transaction } from '../../models/transaction';
import {
    vobClassificationsItem,
    FacilityPayers, emptyVob,
} from 'src/admissions-advisor/models/vob';
import { VerificationOfBenefitsAccordionContents } from '../vob/vob-accordion-contents';
import { FinpassVOBModal } from '../vob/finpass-vob-modal';
import {
    getClientFacilities,
} from '../../../../implementation-specialist/state/facility/implementation-facility-thunk';
import { callNewEstimateGet } from 'src/admissions-advisor/state/estimator-thunk';
import { clearEstimate } from 'src/admissions-advisor/state/estimator-slice';
import { LedgerAccordionContents } from "../transactions/ledger-accordion-contents";
import { TransactionsAccordionContents } from '../transactions/transactions-accordion-contents';
import { LedgerUtils } from 'src/shared/ledger-utils';
import {
    DocumentsAccordionContentsV2, PatientDocument,
} from '../documents/documents-accordion-contents-v2';

let editModalPollingInterval: any; // an interval assigned via setInterval

interface InstanceOfCareProps {
    doesSelectedPatientEncounterExist: boolean;
    doesInsuranceExist: boolean;
    doesChampionExist: boolean;
    doesPaymentProgramExist: boolean;
    doesDownPaymentExist: boolean;
    doesRecurringPaymentExist: boolean;
    isPatientEnrolled: boolean;
    shouldReFetchTransactions: boolean;
    shouldReFetchPaymentMethods: boolean;
    isLoadingTransactions: boolean;
    isLoadingPaymentMethods: boolean;
    handleDisableConvert: (value: string) => void;
    isCovertDisabled: boolean;
    setIsMissingReqModalOpen: (value: boolean, isEnrollFlow?: boolean) => void;
}

const InstanceOfCare = (props: InstanceOfCareProps) => {
    const {
        doesSelectedPatientEncounterExist,
        doesInsuranceExist,
        doesChampionExist,
        doesPaymentProgramExist,
        shouldReFetchPaymentMethods,
        isPatientEnrolled,
        isLoadingTransactions,
        isLoadingPaymentMethods,
        handleDisableConvert,
        isCovertDisabled,
        setIsMissingReqModalOpen,
    } = props;

    const compareFunction = (prevValue: any, nextValue: any) =>
        _.isEqual(prevValue, nextValue);

    const stateFields = {
        selectedPatient: useSelector(
            (state: RootState) => state.patientContext.selectedPatient
        ),
        patientEncounters: useSelector(
            (state: RootState) =>
                state.patientContext.selectedPatient?.patientEncounters
        ),
        selectedPatientEncounter: useSelector(
            (state: RootState) => state.patientContext.selectedEncounter,
            compareFunction
        ),
        selectedPatientChampion: useSelector(
            (state: RootState) =>
                state.patientContext.selectedEncounter?.patientChampion,
            compareFunction
        ),
        userName: useSelector(
            (state: RootState) => state.userContext.userProfile.userName
        ),
        isLoadingEncounter: useSelector(
            (state: RootState) => state.patientContext.isLoading.patientIOC
        ),
        isPreConverted: useSelector(
            (state: RootState) => state.patientContext.isPreConverted
        ),
        lockingModalOpenStatus: useSelector(
            (state: RootState) =>
                state.patientRecordLockingContext.lockingModalOpenStatus
        ),
        patientModalOpenStatus: useSelector(
            (state: RootState) =>
                state.patientRecordLockingContext.patientModalOpenStatus
        ),
        isLockStatusReleased_overview: useSelector(
            (state: RootState) =>
                state.patientRecordLockingContext.isLockStatusReleased_overview
        ),
        lockRequestedById: useSelector(
            (state: RootState) =>
                state.patientRecordLockingContext.lockRequestedById
        ),
        patientS3Documents: useSelector(
            (state: RootState) => state.patientContext.patientS3Documents
        ),
        preconvertedPatients: useSelector(
            (state: RootState) => state.patientContext.preconvertedPatients
        ),
        convertedPatients: useSelector(
            (state: RootState) => state.patientContext.convertedPatients
        ),
        isIOCModalOpen: useSelector(
            (state: RootState) =>
                state.patientRecordLockingContext.patientModalOpenStatus
                    .isIOCModalOpen
        ),
        missingAddressError: useSelector(
            (state: RootState) => state.patientContext.isError.missingAddress
        ),
        authorizationDocumentStatus: useSelector(
            (state: RootState) =>
                state.patientContext.selectedEncounter
                    ?.authorizationDocumentStatus
        ),
        accountHolderContext: useSelector(
            (state: RootState) => state.patientContext?.accountHolderContext
        ),

        isReleaseChargeError: useSelector(
            (state: RootState) => state.patientContext.isError.releaseCharge
        ),
        releasePaymentStatusMsg: useSelector(
            (state: RootState) => state.patientContext.releasePaymentStatusMsg
        ),
        allClients: useSelector(
            (state: RootState) =>
                state.implementationContext?.implementationSpecialistClient
                    ?.allClients
        ),
        allClientsMap: useSelector(
            (state: RootState) =>
                state.implementationContext.implementationSpecialistClient
                    .allClientsMap
        ),
        vob: useSelector(
            (state: RootState) => state.admissionsAdvisorContext.vobContext.vob
        ),
        payers: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext?.payers
        ),
        facilities: useSelector(
            (state: RootState) =>
                state.implementationContext.implementationFacility.facilities
        ),
        estimate: useSelector(
            (state: RootState) => state.admissionsAdvisorContext.estimatorContext.estimate
        ),
        ledgerData: useSelector(
            (state: RootState) => state.patientContext.selectedEncounter?.encounterLedger
        ),
        patientDocuments: useSelector(
            (state: RootState) => state.patientContext.patientDocuments
        ),
    };

    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const countdownMax = configSettings.REACT_APP_patient_locking_countdown_max;
    const lockPollingInterval =
        configSettings.REACT_APP_patient_locking_polling_interval;

    const {
        selectedPatient,
        patientEncounters,
        selectedPatientEncounter,
        userName,
        isLoadingEncounter,
        lockingModalOpenStatus,
        patientModalOpenStatus,
        isLockStatusReleased_overview,
        lockRequestedById,
        patientS3Documents,
        isIOCModalOpen,
        missingAddressError,
        authorizationDocumentStatus,
        accountHolderContext,
        selectedPatientChampion,
        isReleaseChargeError,
        releasePaymentStatusMsg,
        allClients,
        allClientsMap,
        vob,
        payers,
        estimate,
        ledgerData,
        patientDocuments
    } = stateFields;

    const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
    const [isChampionModalOpen, setIsChampionModalOpen] = useState(false);
    const [isVobModalOpen, setIsVobModalOpen] = useState(false);
    const [estimateFeatureFlag, setEstimateFeatureFlag] = useState(true);
    const [vobClassification, setVOBClassification] = useState<
        vobClassificationsItem[] | any[]
    >([]);
    const [isPaymentProgramsModalOpen, setIsPaymentProgramsModalOpen] =
        useState(false);
    const [isPaymentProgramsV2ModalOpen, setIsPaymentProgramsV2ModalOpen] =
        useState(false);
    const [isBalanceAdjustmentModalOpen, setIsBalanceAdjustmentModalOpen] =
        useState(false);
    const [
        isBalanceAdjustmentConfirmModalOpen,
        setIsBalanceAdjustmentConfirmModalOpen,
    ] = useState(false);
    const [balanceAdjustmentModalValues, setBalanceAdjustmentModalValues] =
        useState<BalanceAdjustment>(emptyBalanceAdjustment);
    const [isIOCModalEditMode, setIsIOCModalEditMode] = useState(false);
    const [isRequestReleaseButtonDisabled, setIsRequestReleaseButtonDisabled] =
        useState(false);
    const [isWarmTransferCompleted, setIsWarmTransferCompleted] =
        useState<string>('-1');
    const [isLoadingVOB, setIsLoadingVOB] = useState(false);

    const [facilityPayersState, setFacilityPayersState] =
        useState<FacilityPayers[]>();
    const isTransactionsInit = useRef(false);
    const ledgerLimit = 10

    const hasRunOnce = useRef(false);
    const ledgerDetailsCompletedRef = useRef(false);
    const [isFetchingLedgerDetails, setIsFetchingLedgerDetails] = useState(false);

    // we assume if there is a vob id, there is a vob to work on
    const doesVobExist = Boolean(vob.vobId);

    // const doesLocExist = Array.isArray(estimate?.facilityLevelOfCare) && (estimate?.facilityLevelOfCare ?? []).length > 0;

    const ledgerFetchedRef = useRef(false);
    const ledgerDetailsProcessingRef = useRef(false);
    const processedLedgerIdsRef = useRef<{ [key: number]: boolean }>({});

    // Track when all detailed ledger entries are processed
    useEffect(() => {
        if (ledgerDetailsCompletedRef.current) {
            console.log("Ledger details completed.");
            console.log("Combined ledger data:", {
                ledger: ledgerData
            });
        }
    }, [ledgerData, ledgerDetailsCompletedRef.current]);

    useEffect(() => {
        return () => {
            dispatch(initializePatientVOBState());
            dispatch(clearEstimate());
        };
    }, []);
    useEffect(() => {
        dispatch(configGetPayers(-2));
    }, [selectedPatientEncounter.facilityId]);

    useEffect(() => {
        if (doesVobExist) setIsLoadingVOB(false);
    }, [doesVobExist]);

    const client: ClientStatusCardViewModel | undefined = allClients.find(
        (c: ClientStatusCardViewModel) =>
            c.clientId === selectedPatientEncounter?.clientId
    );

    let isPaymentProgramV2: boolean = false;
    let isV2TxnTableEnabled: boolean = true
    const isBillingEngineV3: boolean = client?.billingEngineVersion === 'V3';

    if (!!client) {
        const { paymentProgramVersion } = client;
        isPaymentProgramV2 = paymentProgramVersion === 2;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (selectedPatientEncounter?.patientEncounterId && isV2TxnTableEnabled && !ledgerFetchedRef.current) {
                await LedgerUtils.fetchLedger({
                    encounterId: selectedPatientEncounter.patientEncounterId,
                    dispatch: dispatch,
                });
            }
        };
        fetchData();
    }, [selectedPatientEncounter?.patientEncounterId, dispatch]);

    const handlePaymentProgramAccordionExpand = () => {
        if (
            doesPaymentProgramExist &&
            shouldReFetchPaymentMethods &&
            !isLoadingPaymentMethods &&
            !missingAddressError
        ) {
            dispatch(
                getPaymentMethods({
                    patientId: selectedPatientEncounter?.patientId,
                    encounterId: selectedPatientEncounter?.patientEncounterId,
                    supressErrors: true,
                })
            );
        }
    };

    const releasePatientLock = () => {
        if (selectedPatientEncounter?.patientEncounterId) {
            setTimeout(async () => {
                await dispatch(lockIOC({ lock: false })); // unlock the IOC
            }, 500);
        }
    };

    const handleIOCModalCancel = () => {
        releasePatientLock();
        dispatch(setIsIOCModalOpen(false));
        clearInterval(editModalPollingInterval);
    };

    const handleIOCModalSubmit = () => {
        dispatch(setIsIOCModalOpen(false));
        clearInterval(editModalPollingInterval);
    };

    const handleInsuranceModalClose = () => {
        setIsInsuranceModalOpen(false);
    };

    const handleChampionModalClose = () => {
        setIsChampionModalOpen(false);
    };

    const handlePaymentProgramsModalClose = () => {
        setIsPaymentProgramsModalOpen(false);
    };

    const handlePaymentProgramsV2ModalClose = () => {
        setIsPaymentProgramsV2ModalOpen(false);
    };

    const handleBalanceAdjustmentModalClose = () => {
        setBalanceAdjustmentModalValues(emptyBalanceAdjustment);
        setIsBalanceAdjustmentModalOpen(false);
    };

    const handleBalanceAdjustmentModalSave = (data: BalanceAdjustment) => {
        setBalanceAdjustmentModalValues(data);
        setIsBalanceAdjustmentModalOpen(false);
        setIsBalanceAdjustmentConfirmModalOpen(true);
    };

    const handleConfirmBalanceAdjustment = () => {
        setBalanceAdjustmentModalValues(emptyBalanceAdjustment);
        setIsBalanceAdjustmentConfirmModalOpen(false);
    };

    const handleChangeBalanceAdjustment = () => {
        setIsBalanceAdjustmentConfirmModalOpen(false);
        setIsBalanceAdjustmentModalOpen(true);
    };

    const insuranceAccordionModalCallback = () => {
        setIsInsuranceModalOpen(true);
    };

    const championAccordionModalCallback = () => {
        setIsChampionModalOpen(true);
    };

    const paymentProgramsModalCallback = () => {
        if (isPaymentProgramV2) setIsPaymentProgramsV2ModalOpen(true);
        else setIsPaymentProgramsModalOpen(true);
    };

    const balanceAdjustmentModalCallback = () => {
        setIsBalanceAdjustmentModalOpen(true);
    };

    const handleVOBModalCancel = () => {
        setIsVobModalOpen(false);
    };

    const handleDocumentAccordionExpand = () => {
        if (doesSelectedPatientEncounterExist) {
            dispatch(
                getDocuments({
                    patientId: selectedPatientEncounter?.patientId,
                    encounterId: selectedPatientEncounter?.patientEncounterId,
                })
            );
            dispatch(
                getS3Document({
                    patientId: selectedPatientEncounter?.patientId,
                    encounterId: selectedPatientEncounter?.patientEncounterId,
                })
            );
        }
    };

    const handleOpenIOCModal = async (isEdit: boolean) => {
        dispatch(setIsIOCModalOpen(true));
        setIsIOCModalEditMode(isEdit);
    };

    const handleNewEstimateView = (estimateId: number) => {
        window.open(
            `/estimate/v4/${estimateId}`,
            '_blank'
        );
    };

    const handleIOCLocking = async () => {
        const patientId = selectedPatientEncounter.patientId;
        const encounterId = selectedPatientEncounter.patientEncounterId;
        const freshIOC = await patientService.getPatientInstanceOfCare({
            patientId,
            encounterId,
        });
        const IOC = freshIOC.entity;
        const isLocked = IOC?.isLocked || false; // Needed to add the default value to avoid undefined for brand new patient

        if (
            isLocked &&
            IOC?.lockedByUserId !== userName &&
            IOC?.lockedByUserId !== null &&
            IOC?.lockedByUserId?.toLowerCase() !== 'undefined'
        ) {
            // extra checks in case of bad data
            setIsRequestReleaseButtonDisabled(false);
            dispatch(setLockRequestedById(IOC.lockedByUserId));
            dispatch(setInUseModalOpen_overview(true));
        } else {
            // patient not locked by anyone. Go ahead and lock it for me so others are locked out
            dispatch(setLockRequestedById(undefined));

            await dispatch(lockIOC({ lock: true, username: userName }));

            doModalPolling(patientId, encounterId);
        }
    };

    useEffect(() => {
        if (
            isIOCModalOpen &&
            selectedPatientEncounter?.patientId &&
            selectedPatientEncounter?.patientEncounterId
        ) {
            handleIOCLocking(); // when ioc modal is open, handle locking logic. both add/edit cases. Only when patientId and encounterId are truthy.
        }
    }, [isIOCModalOpen]);

    useEffect(() => {
        const getVOBClassification = async () => {
            const response =
                await admissionsAdvisorService.getVobClassifications(-2);
            if (response.hasErrors) {
                setVOBClassification([]);
            }
            setVOBClassification(response.entity);
        };

        getVOBClassification();
    }, []);

    useEffect(() => {
        const fetchFacilityPayors = async () => {
            const response =
                await admissionsAdvisorService.getEstimatorFacilityLocPayers(
                    -2,
                    selectedPatientEncounter.facilityId
                );

            let responseBody = { ...response.entity };

            responseBody.masterListPayers = payers;

            const cleanedData: FacilityPayers[] =
                admissionsAdvisorUtils.fillClientPayerDataGaps(responseBody);
            setFacilityPayersState(cleanedData);
        };

        if (payers && payers.length > 0) {
            fetchFacilityPayors();
        }
    }, [payers, selectedPatientEncounter.facilityId]);

    useEffect(() => {
        const handleReleaseError = async () => {
            const paramId = -2;
            const paymentStatus = {
                paymentStatus: 'Failed',
                paymentId: releasePaymentStatusMsg.paymentId,
            };
            await paynowService.updatePaymentDetails(paramId, paymentStatus);

            let clonedEncounter: PatientEncounter = Utils.deepClone(
                selectedPatientEncounter
            );
            const transactionIndex =
                clonedEncounter.patientTransactions.findIndex(
                    (transaction: Transaction) =>
                        transaction.payment.paymentId ===
                        releasePaymentStatusMsg.paymentId
                );
            clonedEncounter.patientTransactions[
                transactionIndex
            ].payment.isCaptured = true;
            clonedEncounter.patientTransactions[
                transactionIndex
            ].payment.paymentStatus = 'Failed';
            clonedEncounter.patientTransactions[
                transactionIndex
            ].payment.paymentStatusFailed = 'Failed';
            dispatch(setSelectedEncounter(clonedEncounter));
            dispatch(clearReleaseChargeError());
        };

        if (
            isReleaseChargeError &&
            releasePaymentStatusMsg.encounterId ===
            selectedPatientEncounter?.patientEncounterId
        ) {
            const stripeRefundStatus =
                releasePaymentStatusMsg.errorMsg?.includes(
                    'charge_already_refunded'
                );
            if (stripeRefundStatus) {
                handleReleaseError();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReleaseChargeError]);

    const doModalPolling = useCallback(
        async (patientId: number, encounterId: number) => {
            editModalPollingInterval = setInterval(async () => {
                dispatch(
                    editModalPoll({
                        patientId,
                        encounterId,
                        userName,
                        lockablePatientRecordSection:
                            LockablePatientRecordSection.overview,
                    })
                );
            }, lockPollingInterval);
        },
        [dispatch, userName]
    );

    const handleRequestReleaseOk = async () => {
        setIsRequestReleaseButtonDisabled(true);
        dispatch(
            requestReleaseOk({
                userName: userName,
                lockablePatientRecordSection:
                    LockablePatientRecordSection.overview,
            })
        );
    };

    const handleRequestReleaseCancel = () => {
        resetRedux();
        dispatch(setInUseModalOpen_overview(false));
        navigate('/specialist/dashboard');
    };

    const handleReleaseRecordOk = async () => {
        dispatch(
            releaseRecordOk({
                lockablePatientRecordSection:
                    LockablePatientRecordSection.overview,
            })
        );
        dispatch(setIsIOCModalOpen(false));
        clearInterval(editModalPollingInterval);
    };

    const handleRequestDeniedClose = () => {
        resetRedux();
        navigate('/specialist/dashboard');
        dispatch(setRequestDeniedModalOpen_overview(false));
    };

    const resetRedux = () => {
        dispatch(resetPatientContext());
        dispatch(resetPatientRecordLockingContext());
    };

    const handleWarmTransfer = (event: { target: { value: string } }) => {
        setIsWarmTransferCompleted(event.target.value as string);
        handleDisableConvert(event.target.value);
        dispatch(
            updateWarmTransfer({
                isWarmTransferCompleted:
                    event.target.value === 'Yes'
                        ? true
                        : event.target.value === 'No'
                            ? false
                            : null,
            })
        );
    };

    const formRef: any = useRef();

    useEffect(() => {

        if (selectedPatientEncounter?.isWarmTransferCompleted === true) {
            setIsWarmTransferCompleted('Yes');
            handleDisableConvert('Yes');
        }
        if (selectedPatientEncounter?.isWarmTransferCompleted === false) {
            setIsWarmTransferCompleted('No');
            handleDisableConvert('No');
        }
        if (selectedPatientEncounter?.isWarmTransferCompleted === null) {
            setIsWarmTransferCompleted('-1');
            handleDisableConvert('-1');
        }
    }, [selectedPatientEncounter]);

    useEffect(() => {
        const patientId = selectedPatientEncounter?.patientId;
        const encounterId = selectedPatientEncounter?.patientEncounterId;

        const abortController = new AbortController();

        if(selectedPatientEncounter?.patientId &&
            selectedPatientEncounter?.patientEncounterId){
            void Promise.all([
                handleDocumentAccordionExpand(),
                dispatch(
                    getPatientDocuments({
                        encounterId,
                        fetchSmsEligibility: true,
                        cancelSignal: abortController.signal
                    })
                ),
                dispatch(
                    getPatientNotes({
                        patientId,
                        encounterId,
                    })
                ),
            ])
        }

        return () => {
            abortController.abort();
        };

    }, [
        dispatch,
        selectedPatientEncounter?.patientId,
        selectedPatientEncounter?.patientEncounterId,
    ]);

    // Add a ref to track component mount state
    const isInitialMount = useRef(true);
    const previousEncounterId = useRef<number | undefined>(0);
    const previousPatientId = useRef<number | undefined>(undefined);
    const lastFetchedRef = useRef<{ patientId?: number; encounterId?: number }>({});

    // This effect will run when the component mounts or when selectedPatientEncounter changes
    useEffect(() => {
        const patientId = selectedPatientEncounter?.patientId;
        const encounterId = selectedPatientEncounter?.patientEncounterId;

        // Check if this is the initial mount and the encounterId is 0 or undefined
        if (isInitialMount.current) {
            isInitialMount.current = false;

            // If encounterId is 0 on initial mount, we're likely coming from demographics
            // Set the previous ID to track changes
            previousEncounterId.current = encounterId;
            previousPatientId.current = patientId;

            // If we have a patient ID but encounterId is 0, we need to fetch the encounter
            if (patientId && (!encounterId || encounterId === 0)) {
                console.log("Initial load with encounterId 0, fetching encounter data");
                dispatch(
                    getInstanceOfCare({
                        patientId: patientId,
                        encounterId: patientId, // Use patientId as fallback if needed
                    })
                );
            }
        }
        else if (
            encounterId !== previousEncounterId.current || 
            patientId !== previousPatientId.current
        ) {
            console.log(`EncounterId changed from ${previousEncounterId.current} to ${encounterId}, fetching new data`);
            previousEncounterId.current = encounterId;
            previousPatientId.current = patientId;

            // Only fetch if we have valid data and encounterId is not 0
            // Also check if we've already fetched this exact combination to prevent infinite loops
            if (
                selectedPatientEncounter &&
                selectedPatientEncounter !== emptyPatientEncounter &&
                patientId &&
                encounterId &&
                encounterId !== 0 &&
                selectedPatient?.patientEncounters?.length > 0 &&
                (lastFetchedRef.current.patientId !== patientId || 
                 lastFetchedRef.current.encounterId !== encounterId)
            ) {
                lastFetchedRef.current = {
                    patientId: patientId,
                    encounterId: encounterId,
                };
                
                dispatch(
                    getInstanceOfCare({
                        patientId: patientId,
                        encounterId: encounterId,
                    })
                );

                if (patientId !== 0 && encounterId !== 0 && doesPaymentProgramExist) {
                    handlePaymentProgramAccordionExpand();
                }
            }
        }

        // Reset flag and refs when component unmounts
        return () => {
            isInitialMount.current = true;
            previousEncounterId.current = 0;
            previousPatientId.current = undefined;
        };
    }, [dispatch, selectedPatientEncounter?.patientId, selectedPatientEncounter?.patientEncounterId, doesPaymentProgramExist, selectedPatient?.patientEncounters?.length]);

    useEffect(() => {
        if (selectedPatientEncounter?.pfrEstimateId) {
            dispatch(callNewEstimateGet({
                paramId: 0,
                estimationId: selectedPatientEncounter?.pfrEstimateId!,
            }));
        } else if (selectedPatientEncounter.patientEncounterId && !selectedPatientEncounter?.pfrEstimateId && selectedPatientEncounter?.payorRisk?.payorRiskId === 3) {
            dispatch(setVobAndEstimate({
                vob: {
                    ...emptyVob,
                    client: {
                        clientId: selectedPatientEncounter.clientId,
                        clientName: selectedPatientEncounter.clientName,
                        clientList: [],
                    },
                    facility: {
                        facilityId: selectedPatientEncounter.facilityId,
                        facilityName: selectedPatientEncounter.facilityName,
                        facilityList: [],
                    },

                },
            }))
        } else {
            dispatch(clearEstimate());
            dispatch(initializePatientVOBState());
        }
    }, [selectedPatientEncounter?.pfrEstimateId]);

    useEffect(() => {
        if (estimate?.vobId) {
            setIsLoadingVOB(true);
            dispatch(getVOBForPatientRecords(estimate?.vobId))
            setIsLoadingVOB(false);
        }
    }, [estimate?.vobId])

    useEffect(() => {
        async function getRecentlyViewedData() {
            const recentlyViewedListFromCookie: UsersCookiesList =
                Cookies.getJSON('recentlyViewed');
            if (recentlyViewedListFromCookie) {
                const { usersCookiesList } = recentlyViewedListFromCookie;
                const index = usersCookiesList?.findIndex(
                    (recentlyViewed: RecentlyViewedUser) =>
                        recentlyViewed.userName === userName
                );
                if (index >= 0) {
                    await dispatch(
                        setRecentlyViewedPatients({
                            recentlyViewed:
                                usersCookiesList[index].preConvertedPatients,
                            type: RecentlyViewedTypes.preConvertedPatients,
                        })
                    );
                }
                if (index >= 0) {
                    await dispatch(
                        setRecentlyViewedPatients({
                            recentlyViewed:
                                usersCookiesList[index].convertedPatients,
                            type: RecentlyViewedTypes.convertedPatients,
                        })
                    );
                }
            }

            if (selectedPatientEncounter) {
                const { isConverted, patientId, patientEncounterId, workflow } =
                    selectedPatientEncounter;
                if (workflow?.workflowId === 3) {
                    await dispatch(
                        setRecentlyViewedPatient({
                            patientId,
                            encounterId: patientEncounterId,
                            type: RecentlyViewedTypes.convertedPatients,
                        })
                    );
                } else {
                    await dispatch(
                        setRecentlyViewedPatient({
                            patientId,
                            encounterId: patientEncounterId,
                            type: RecentlyViewedTypes.preConvertedPatients,
                        })
                    );
                }
            }
        }

        getRecentlyViewedData();
    }, [dispatch, selectedPatientEncounter]);

    useEffect(() => {
        if (isLockStatusReleased_overview) {
            doModalPolling(
                selectedPatientEncounter?.patientId,
                selectedPatientEncounter?.patientEncounterId
            );
            dispatch(setLockStatusReleased_overview(false));
        }
    }, [
        doModalPolling,
        isLockStatusReleased_overview,
        selectedPatientEncounter?.patientId,
        selectedPatientEncounter?.patientEncounterId,
    ]);

    const fetchPaymentInfo = async () => {
        if (!isLoadingPaymentMethods && !missingAddressError) {
            await dispatch(
                getPaymentMethods({
                    patientId: selectedPatientEncounter?.patientId,
                    encounterId: selectedPatientEncounter?.patientEncounterId,
                    supressErrors: true,
                })
            );
        }
        if (!isLoadingTransactions && !missingAddressError && !isV2TxnTableEnabled) {
            await LedgerUtils.fetchLedger({
                encounterId: selectedPatientEncounter?.patientEncounterId,
                dispatch: dispatch,
            });
        }
    };

    useEffect(() => {
        if (
            selectedPatientEncounter?.patientEncounterId &&
            !isLoadingEncounter &&
            !isTransactionsInit.current
        ) {
            isTransactionsInit.current = true;
            fetchPaymentInfo();
        }
    }, []);

    useEffect(() => {
        if (selectedPatientEncounter?.patientEncounterId && !missingAddressError && !isV2TxnTableEnabled) {
            LedgerUtils.fetchLedger({
                encounterId: selectedPatientEncounter.patientEncounterId,
                dispatch: dispatch,
            });
        }
    }, [selectedPatientEncounter?.patientEncounterId]);

    const asyncFetchPatientEncounter = (
        patientId: number,
        encounterId: number,
        isPreConverted: boolean
    ): Promise<void> => {
        return new Promise((resolve, reject) => {
            // Assuming getInstanceOfCare is an asynchronous action
            dispatch(
                getInstanceOfCare({
                    patientId: patientId,
                    encounterId: encounterId,
                })
            ).then(
                (result: any) => {
                    // You can resolve with a meaningful value if needed
                    resolve(result);
                },
                error => {
                    // You can reject with the error if needed
                    reject(error);
                }
            );
        });
    };

    const setInitialAccountHolderContext = async (
        contactInfo: PrimaryContact,
        isPatient: boolean
    ) => {
        const accountHolderContext = {
            userName: contactInfo.email,
            isPatient,
            firstName: contactInfo.firstName,
            lastName: contactInfo.lastName,
        };

        if (!contactInfo.email) {
            dispatch(
                setAccountHolderContext({
                    ...accountHolderContext,
                    isExistingEmail: null,
                    userId: null,
                })
            );
            return;
        }

        const response = await userService.getAllUsers(0, 1000, {
            userName: contactInfo.email,
        });

        const { entity } = response;
        const isExistingEmail = entity.length >= 1;
        const userId = entity[0]?.userId || null;

        // if we navigate back from adding an email to the patient's demographic info
        // but loginVerified is still null...
        if (selectedPatientEncounter.loginVerified === null) {
            // and they've already chose a champion
            if (doesChampionExist || selectedPatientChampion) {

                let getUserResponse;
                if (userId) {
                    getUserResponse = await userService.getUser(userId!);
                }

                // and the email exists and the user has changed the temp password
                if (isExistingEmail && getUserResponse?.fullUser?.cognitoStatus?.UserStatus === "CONFIRMED") {
                    // email verification wasn't sent... so send it
                    const result = await userService.sendVerificationEmail(
                        userId,
                        selectedPatientEncounter.patientEncounterId
                    );

                    if (result.hasErrors) {
                        dispatch(
                            showErrorStatus(
                                `Email failed to send. Please resend`
                            )
                        );
                    }

                    // update status ioc verified status to pending
                    await dispatch(
                        updateIOC({ loginVerified: LoginVerifiedStatus.pending })
                    );

                    dispatch(
                        setAccountHolderContext({
                            ...accountHolderContext,
                            isExistingEmail,
                            userId,
                        })
                    );
                    return;
                } else {
                    // they've chosen a champion,but the emails is not an existing email
                    await dispatch(
                        updateIOC({ loginVerified: LoginVerifiedStatus.verified })
                    );

                    dispatch(
                        setAccountHolderContext({
                            ...accountHolderContext,
                            isExistingEmail,
                            userId,
                        })
                    );
                    return;
                }
            }
        }

        dispatch(
            setAccountHolderContext({
                ...accountHolderContext,
                isExistingEmail,
                userId,
            })
        );
    };

    const whoIsTheAccountHolder = (
        patientChampions: PatientChampion[],
        selectedPatient: any
    ) => {
        const guarantor = patientChampions.filter((champion: any) => {
            return champion.isGuarantor;
        });
        if (guarantor.length >= 1) {
            return {
                isPatient: false,
                accountHolder: guarantor[0],
            };
        } else {
            return {
                isPatient: true,
                accountHolder: selectedPatient,
            };
        }
    };

    useEffect(() => {
        if (selectedPatientEncounter.clientId > 0) dispatch(
            getClientFacilities(selectedPatientEncounter.clientId)
        )
    }, [selectedPatientEncounter.clientId])

    useEffect(() => {
        // run on mount only
        // selected encounter takes a second to load
        if (isLoadingEncounter) return;
        if (selectedPatientChampion === undefined) return;
        if (!doesChampionExist) return;
        if (hasRunOnce.current) return;

        const { accountHolder, isPatient } = whoIsTheAccountHolder(
            selectedPatientChampion,
            selectedPatient
        );

        setInitialAccountHolderContext(accountHolder.contact, isPatient);
        hasRunOnce.current = true;

        return () => {
            hasRunOnce.current = false;
            dispatch(setAccountHolderContext({ type: 'reset' }));
        };
    }, [selectedPatientChampion]);

    async function handleDropdown() {
        const formValues = formRef?.current?.values;
        if (formValues?.instanceOfCareId !== '-1') {
            const selPatientEncounter =
                patientEncounters &&
                patientEncounters.find(
                    (patientEncounter: PatientEncounter) =>
                        parseInt(formValues?.instanceOfCareId) ===
                        patientEncounter?.patientEncounterId
                );

            if (selPatientEncounter?.patientEncounterId) {
                try {
                    // Reset the ledger fetch ref and state so we can fetch for the new encounter
                    ledgerFetchedRef.current = false;
                    setLedgerData({ ledger: [], pagination: { hasMore: false } });

                    await new Promise((resolve, reject) => {
                        asyncFetchPatientEncounter(
                            selPatientEncounter.patientId,
                            selPatientEncounter.patientEncounterId,
                            stateFields.isPreConverted
                        )
                            .then(async (result: any) => {
                                console.log("About to update encounter, payload:", result.payload);
                                await dispatch(
                                    setSelectedEncounter(
                                        result.payload
                                            .selectedPatientEncounter !==
                                            emptyPatientEncounter
                                            ? result.payload
                                                .selectedPatientEncounter
                                            : selPatientEncounter
                                    )
                                );
                                console.log("Encounter updated, ledgerFetchedRef reset for new fetch");
                                resolve(result);
                            })
                            .catch(reject);
                    });
                } catch (error) {
                    // Handle any errors that occur during the asynchronous fetch
                    console.error('Error fetching patient encounter:', error);
                }
            }
        }
    }

    const showInstanceOfCareText = (
        <Box
            display="flex"
            width={'100%'}
            alignItems="center"
            justifyContent="center"
        >
            <span className="title">Add an Instance of Care</span>
        </Box>
    );

    const initialValues = {
        instanceOfCareId:
            selectedPatientEncounter?.patientEncounterId === 0
                ? '-1'
                : selectedPatientEncounter?.patientEncounterId,
        previousInstanceOfCareId:
            selectedPatientEncounter?.patientEncounterId === 0
                ? '-1'
                : selectedPatientEncounter?.patientEncounterId,
    };

    const admissionDate = selectedPatientEncounter?.admissionDt
        ? new Date(selectedPatientEncounter.admissionDt)
        : '';

    const dischargeDate = selectedPatientEncounter?.dischargeDt
        ? new Date(selectedPatientEncounter.dischargeDt)
        : '';

    const isSelfPay = selectedPatientEncounter?.payorRisk?.payorRiskId === 3;

    let accountHolderIcon;
    switch (selectedPatientEncounter?.loginVerified) {
        case LoginVerifiedStatus.pending:
            accountHolderIcon = <PendingOutlined sx={{ color: '#f2db00' }} />;
            break;
        case LoginVerifiedStatus.verified:
            accountHolderIcon = (
                <CheckCircleOutlineIcon className="green-icon" />
            );
            break;
        case null:
        default:
            accountHolderIcon = (
                <RadioButtonUncheckedIcon className="gray-icon" />
            );
    }

    const isClientsLoaded = allClientsMap?.size > 0

    const clientCardForDocsAccordion =
        allClientsMap?.get(selectedPatientEncounter.clientId);

    const isDocumentAccordionV2 =
        !!selectedPatientEncounter.clientId &&
        !!clientCardForDocsAccordion &&
        clientCardForDocsAccordion.convRunNum != null &&
        clientCardForDocsAccordion.convRunNum > 76;

    const iocAccordionContents = (
        <div>
            <Grid container justifyContent="space-between">
                <>
                    <Grid item xs={10} />
                    <Box justifyContent="flex-end">
                        <Grid item xs={2}>
                            <AccessControl
                                rolePageName={RolePageNames.PatientRecords}
                                actionName="Add Instance of Care"
                                renderNoAccess={() => (
                                    <IconButton disabled size="large">
                                        {' '}
                                        <EditIcon className="colorDisabled" />
                                    </IconButton>
                                )}
                                test-id="add-instance-of-care-button2"
                            >
                                <IconButton
                                    onClick={() => handleOpenIOCModal(true)}
                                    size="large"
                                    test-id="edit-IOC-button"
                                >
                                    {' '}
                                    <EditIcon className="icon" />
                                </IconButton>
                            </AccessControl>
                        </Grid>
                    </Box>
                </>
                <HeaderWithDetails
                    header="Provider"
                    details={selectedPatientEncounter?.clientName}
                    width="half"
                />
                <HeaderWithDetails
                    header="Facility"
                    details={selectedPatientEncounter?.facilityName}
                    width="half"
                />
                <HeaderWithDetails
                    header="CRM Account ID"
                    details={selectedPatientEncounter?.clientsPatientAccountId}
                    width="half"
                />
                <HeaderWithDetails
                    header="CRM IOC ID"
                    details={selectedPatientEncounter?.clientsPatientIOCId}
                    width="half"
                />
                <HeaderWithDetails
                    header="Billing Account ID"
                    details={selectedPatientEncounter?.extBillingPatientAccountId}
                    testId="Billing-Account-Id"
                    width="half"
                />
                <HeaderWithDetails
                    header="Billing IOC ID"
                    details={selectedPatientEncounter?.clientBillingIOCId}
                    testId="Billing-IOC-Id"
                    width="half"
                />
                <HeaderWithDetails
                    header="Adjusted PFR"
                    details={formatNumberToUSD(
                        selectedPatientEncounter?.adjustedPfrAmt
                    )}
                    width="half"
                    testId='current-pfr-amt'
                />
                <HeaderWithDetails
                    header="Type of Care"
                    details={selectedPatientEncounter?.typeOfCare?.typeOfCare}
                    width="half"
                />
                {selectedPatientEncounter?.levelOfCare && (<HeaderWithDetails
                    header="Level of Care"
                    details={selectedPatientEncounter?.levelOfCare}
                    width="half"
                />)}
                <HeaderWithDetails
                    header="Timing Risk"
                    details={
                        selectedPatientEncounter?.timingRisk?.timingRiskName
                    }
                    width="half"
                />
                <HeaderWithDetails
                    header="Payor Risk"
                    details={selectedPatientEncounter?.payorRisk?.payorRiskName}
                    width="half"
                />
                <HeaderWithDetails
                    header="Risk Class"
                    details={selectedPatientEncounter?.riskClass?.riskClassName}
                    width="half"
                />
                <HeaderWithDetails
                    header="Paid to Patient"
                    details={
                        selectedPatientEncounter?.paidToPatient === true
                            ? 'Yes'
                            : 'No'
                    }
                    width="half"
                />
                {admissionDate !== '' ? (
                    <HeaderWithDetails
                        header="Admission"
                        details={Utils.convertDate(admissionDate)}
                        width="half"
                    />
                ) : (
                    <HeaderWithDetails header="Admission" width="half" />
                )}
                {dischargeDate !== '' ? (
                    <HeaderWithDetails
                        header="Discharge"
                        details={Utils.convertDate(dischargeDate)}
                        width="half"
                    />
                ) : (
                    <HeaderWithDetails header="Discharge" width="half" />
                )}
                <Grid item xs={12} sm={6}>
                    <div style={{ width: '80%' }}>
                        <TextField
                            select={true}
                            label="Warm Transfer Completed?"
                            name="isWarmTransferCompleted"
                            value={isWarmTransferCompleted}
                            onChange={(event: { target: { value: string } }) => {
                                handleWarmTransfer(event);
                            }}
                            onBlur={() => { }}
                            disabled={selectedPatientEncounter?.workflow?.workflowId === 3}
                        >
                            <MenuItem value="-1">N/A</MenuItem>
                            <MenuItem value={'Yes'}>Yes</MenuItem>
                            <MenuItem value={'No'}>No</MenuItem>
                        </TextField>
                    </div>

                </Grid>
                {selectedPatientEncounter?.pfrEstimateId && estimate && estimateFeatureFlag && (
                    <HeaderWithDetails
                        header="Estimate"
                        details={
                            <IconButton
                                title="View Estimate"
                                style={{ fontSize: '14pt', color: '#00508E' }}
                                onClick={() => handleNewEstimateView(selectedPatientEncounter?.pfrEstimateId!)}
                                size="large"
                            >
                                <SummarizeOutlinedIcon /> View Estimate
                            </IconButton>
                        }
                        width="half"
                    />
                )}
                <HeaderWithDetails
                    testId="ioc-workflow-status"
                    header="Workflow Status"
                    width="full"
                    details={
                        <Status
                            typographyVariant="h3"
                            text={`
              ${selectedPatientEncounter?.workflow?.workflowStatus
                                    ?.workflowStatusDesc}${selectedPatientEncounter?.workflow?.workflowSubStatus
                                        ?.workflowSubStatusDesc
                                        ? ' - ' +
                                        selectedPatientEncounter?.workflow?.workflowSubStatus
                                            ?.workflowSubStatusDesc
                                        : ''
                                }`}
                            statusColor={
                                selectedPatientEncounter?.workflow
                                    ?.workflowSubStatus
                                    ?.workflowSubStatusDesc === 'None'
                                    ? getPatientStatusByStatusId(
                                        selectedPatientEncounter?.workflow
                                            ?.workflowStatus
                                            ?.workflowStatusId,
                                        StatusType['primary-status'],
                                        selectedPatientEncounter?.workflow
                                            ?.workflowId
                                    ).color
                                    : getPatientStatusByStatusId(
                                        selectedPatientEncounter?.workflow
                                            ?.workflowSubStatus
                                            ?.workflowSubStatusId,
                                        StatusType['sub-status'],
                                        selectedPatientEncounter?.workflow
                                            ?.workflowId
                                    ).color
                            }
                        />
                    }
                />
            </Grid>
            {
                isClientsLoaded ?
                    !isDocumentAccordionV2 ?
                        <CustomizeableAccordion
                            icon={
                                authorizationDocumentStatus?.overallDocumentStatus ===
                                SignatureStatus.SignatureCompleted ? (
                                    <CheckCircleOutlineIcon className="green-icon" />
                                ) : authorizationDocumentStatus?.overallDocumentStatus ===
                                'No Documents' ||
                                !authorizationDocumentStatus?.overallDocumentStatus ? (
                                    <RadioButtonUncheckedIcon className="gray-icon" />
                                ) : (
                                    <PendingOutlined sx={{ color: '#f2db00' }} />
                                )
                            }
                            headerText="Document Statuses"
                            details={<DocumentsStatusAccordion />}
                        /> :
                        null :
                        <LoadingOverlay whiteBackground={true}/>
            }

            <CustomizeableAccordion
                icon={accountHolderIcon}
                headerText="Account Holder Status"
                details={
                    <AccountStatusAccordian
                        encounter={selectedPatientEncounter}
                        firstName={accountHolderContext.firstName}
                        lastName={accountHolderContext.lastName}
                        userName={accountHolderContext.userName}
                        isPatient={accountHolderContext.isPatient}
                        userId={accountHolderContext.userId}
                    />
                }
            />
        </div>
    );

    const financialClearanceStatusView = doesSelectedPatientEncounterExist ? (
        <Box sx={{ mb: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <HeaderWithDetails
                        testId="ioc-financial-clearance-status"
                        header="Financial Clearance Status"
                        width="full"
                        details={
                            <Status
                                typographyVariant="h3"
                                statusColor={
                                    selectedPatientEncounter?.finClearanceStatus
                                        ? getFinancialStatusColor(
                                            selectedPatientEncounter.finClearanceStatus
                                        )
                                        : StatusColors.blue
                                }
                                text={
                                    selectedPatientEncounter?.finClearanceStatus
                                }
                            />
                        }
                    />
                </Grid>
                <Grid item xs={6}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography variant="body2" sx={{ mb: 1 }}>
                            Pending Remaining Balance
                        </Typography>
                        <Typography variant="h3" test-id="ioc-remaining-balance">
                            {formatNumberToUSD(
                                selectedPatientEncounter?.patientPaymentProgram?.[0]?.patientPaymentSchedule?.pfrPendingBalance ?? 
                                selectedPatientEncounter?.adjustedPfrAmt ?? 0
                            )}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    ) : null;

    const instanceOfCareOverview = (
        <CustomizeableAccordion
            icon={<FolderOpenIcon className="gray-icon" />}
            headerText="Overview"
            details={doesSelectedPatientEncounterExist && iocAccordionContents}
            isDefaultExpanded
        />
    );

    const insuranceView = (
        <CustomizeableAccordion
            icon={
                doesInsuranceExist ? (
                    <CheckCircleOutlineIcon className="green-icon" />
                ) : (
                    <RadioButtonUncheckedIcon className="gray-icon" />
                )
            }
            headerText="Insurance"
            details={doesInsuranceExist && <InsuranceAccordionContents />}
            openModalCallback={insuranceAccordionModalCallback}
            rolePageName={RolePageNames.PatientRecords}
            actionName="Add Instance of Care"
            isStart
        />
    );

    const vobAccordion = (
        <CustomizeableAccordion
            icon={
                (doesVobExist) ? (
                    <CheckCircleOutlineIcon className="green-icon" />
                ) : (
                    <RadioButtonUncheckedIcon className="gray-icon" />
                )
            }
            headerText="Verification Of Benefits"
            details={
                (doesVobExist) && (
                    <VerificationOfBenefitsAccordionContents
                        vobClassification={vobClassification}
                        facilityPayersState={facilityPayersState}
                    />
                )
            }
            openModalCallback={() => {
                setIsVobModalOpen(true);
            }}
            rolePageName={RolePageNames.PatientRecords}
            actionName="Add Instance of Care"
            isStart
            test-id="add-instance-of-care-button4"
        />
    );

    // const locAccordion = (
    //     <CustomizeableAccordion
    //         icon={
    //             doesLocExist ? (
    //                 <CheckCircleOutlineIcon className="green-icon" />
    //             ) : (
    //                 <RadioButtonUncheckedIcon className="gray-icon" />
    //             )
    //         }
    //         headerText="Levels of Care"
    //         details={
    //             doesLocExist && (
    //                 <LevelsOfCareAccordionContents/>
    //             )
    //         }
    //         openModalCallback={() => {
    //             setIsLocModalOpen(true);
    //         }}
    //         rolePageName={RolePageNames.PatientRecords}
    //         actionName="Add Instance of Care"
    //         isStart
    //         isDisabled={(!doesVobExist && selectedPatientEncounter.payorRisk?.payorRiskId !== 3) || selectedPatientEncounter.workflow.workflowId ===3}
    //     />
    // );

    const patientChampionsView = (
        <CustomizeableAccordion
            icon={
                doesChampionExist ||
                    selectedPatientEncounter?.patientChampion?.length > 0 ||
                    selectedPatientEncounter?.hasChampions === false ? (
                    <CheckCircleOutlineIcon className="green-icon" />
                ) : (
                    <RadioButtonUncheckedIcon className="gray-icon" />
                )
            }
            details={
                ((doesSelectedPatientEncounterExist && doesChampionExist) ||
                    selectedPatientEncounter?.hasChampions === false) && (
                    <ChampionAccordionContents />
                )
            }
            headerText="Patient Champions"
            openModalCallback={championAccordionModalCallback}
            rolePageName={RolePageNames.PatientRecords}
            actionName="Apply Payment Program"
            isStart
        />
    );

    const paymentProgramView = (
        <CustomizeableAccordion
            hasScroll
            icon={
                isPatientEnrolled ? (
                    <CheckCircleOutlineIcon className="green-icon" />
                ) : (
                    <RadioButtonUncheckedIcon className="gray-icon" />
                )
            }
            details={
                doesPaymentProgramExist && (
                    <div className="w-100">
                        <PaymentProgramAccordionContents
                            isCovertDisabled={isCovertDisabled}
                            isPaymentProgramV5={isPaymentProgramV2}
                            setIsMissingReqModalOpen={setIsMissingReqModalOpen}
                            isFetchingLedgerDetails={isFetchingLedgerDetails}
                            ledgerData={ledgerData}
                        />
                    </div>
                )
            }
            headerText="Payment Program"
            test-id="payment-program-accordion"
            openModalCallback={paymentProgramsModalCallback}
            expandCallback={handlePaymentProgramAccordionExpand}
            rolePageName={RolePageNames.PatientRecords}
            actionName="Apply Payment Program"
            isStart
        />
    );

    const documentsView = (
        <CustomizeableAccordion
            icon={<InsertDriveFileIcon className="gray-icon" />}
            details={
                isClientsLoaded ?
                    (isDocumentAccordionV2 ?
                        <div className="w-100">
                            <DocumentsAccordionContentsV2
                                documents={patientDocuments}
                                patientId={selectedPatientEncounter.patientId}
                                patientEncounterId={selectedPatientEncounter.patientEncounterId}
                            />
                        </div> :
                        <div className="w-100">
                            <DocumentsAccordionContents
                                documents={selectedPatientEncounter?.patientDocument}
                                selectedEncounter={selectedPatientEncounter}
                                s3Documents={patientS3Documents}
                            />
                        </div>) :
                    <LoadingOverlay whiteBackground={true}/>
            }
            hasScroll
            headerText="Documents"
            expandCallback={()=>{}}
            openModalCallback={() => { }}
        />
    );

    const paymentStatusView = (
        <CustomizeableAccordion
            icon={<AttachMoneyIcon className="gray-icon" />}
            details={
                <div className="w-100">
                    <PaymentStatusAccordionContents
                        setBalanceAdjustmentModalOpen={
                            balanceAdjustmentModalCallback
                        }
                        documents={selectedPatientEncounter?.patientDocument}
                        isV2TxnTableEnabled={isV2TxnTableEnabled}
                        limit={ledgerLimit}
                    />
                </div>
            }
            expandCallback={()=>{}}
            headerText="Payment Status"
        />
    );

    const paymentStatusV2View = (
        <CustomizeableAccordion
            icon={<AttachMoneyIcon className="gray-icon" />}
            details={
                <div className="w-100">
                    <ProgramStatusAccordionContents
                        setBalanceAdjustmentModalOpen={
                            balanceAdjustmentModalCallback
                        }
                        documents={selectedPatientEncounter?.patientDocument}
                        isV2TxnTableEnabled={isV2TxnTableEnabled}
                        limit={ledgerLimit}
                    />
                </div>
            }
            expandCallback={()=>{}}
            headerText="Program Status"
        />
    );

    const transactionsView = (
        <>
            {!isV2TxnTableEnabled &&
                <CustomizeableAccordion
                    hasScroll
                    icon={<CompareArrowsIcon className="gray-icon" />}
                    dataTestId='ledger-accordion'
                    details={
                        <div className="w-100">
                            {selectedPatientEncounter?.patientPaymentProgram?.length >
                                0 ? (
                                <TransactionsAccordionContents
                                    selectedEncounter={selectedPatientEncounter}
                                    isV2TxnTableEnabled={isV2TxnTableEnabled}
                                    limit={ledgerLimit}
                                />
                            ) : (
                                <Typography variant="body1">
                                    There are no transactions available
                                    <Box display="flex" justifyContent="flex-end" alignItems="center">
                                        <IconButton
                                            onClick={() => LedgerUtils.fetchLedger({
                                                encounterId: selectedPatientEncounter.patientEncounterId,
                                                dispatch: dispatch,
                                            })}
                                            size="large"
                                            style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                                        >
                                            <RefreshIcon className="icon" />
                                            <Typography variant="body1" style={{ marginLeft: '4px' }}>
                                                Refresh Transactions
                                            </Typography>
                                        </IconButton>
                                    </Box>
                                </Typography>
                            )}
                        </div>
                    }
                    headerText="Transactions"
                    // expandCallback={handleTransactionsAccordionExpand}
                    openModalCallback={() => { }}
                />}

            {isV2TxnTableEnabled &&
                <CustomizeableAccordion
                    hasScroll
                    icon={<CompareArrowsIcon className="gray-icon" />}
                    dataTestId='ledger-accordion'
                    details={
                        <div className="w-100">
                            {ledgerData?.ledger && ledgerData.ledger.length > 0 ? (
                                <LedgerAccordionContents
                                    isAccountHolder={false}
                                    limit={ledgerLimit}
                                    isFetchingLedgerDetails={isFetchingLedgerDetails}
                                    test-id="ledger-accordion-contents"
                                />
                            ) : (
                                <Typography variant="body1" test-id="ledger-accordion-contents-empty">
                                    There are no transactions available
                                    <Box display="flex" justifyContent="flex-end" alignItems="center">
                                        <IconButton
                                            onClick={() => LedgerUtils.fetchLedger({
                                                encounterId: selectedPatientEncounter.patientEncounterId,
                                                dispatch: dispatch,
                                            })}
                                            size="large"
                                            style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                                        >
                                            <RefreshIcon className="icon" />
                                            <Typography variant="body1" style={{ marginLeft: '4px' }} test-id="refresh-transactions-button">
                                                Refresh Transactions
                                            </Typography>
                                        </IconButton>
                                    </Box>
                                </Typography>
                            )}
                        </div>
                    }
                    headerText="Transactions"
                    openModalCallback={() => { }}
                />
            }
        </>
    );

    const instanceOfCareDetails = patientEncounters && (
        <Grid container spacing={2}>
            <Grid item xs={8}>
                <Formik
                    innerRef={formRef}
                    initialValues={initialValues}
                    onSubmit={() => { }}
                    validate={() => {
                        setTimeout(() => {
                            handleDropdown();
                        }, 50);
                    }} // helps ensure formik state is up-to-date before using it in handleDropdown.
                >
                    {(formik: any) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} className="mb-4" test-id="select-ioc">
                                    <TextField
                                        select={true}
                                        error={
                                            formik.touched[
                                            'instanceOfCareId'
                                            ] &&
                                            formik.errors['instanceOfCareId']
                                        }
                                        label="Instance Of Care"
                                        name="instanceOfCareId"
                                        value={formik.values.instanceOfCareId}
                                        onChange={(e: any) => {
                                            dispatch(clearEstimate());
                                            dispatch(initializePatientVOBState());
                                            formik.handleChange(e);
                                        }}
                                        onBlur={formik.handleBlur}
                                        test-id="select-ioc-input"
                                    >
                                        <MenuItem value="-1">
                                            Select Instance Of Care
                                        </MenuItem>
                                        {patientEncounters.map(
                                            (encounter: PatientEncounter) => (
                                                <MenuItem
                                                    key={
                                                        encounter?.patientEncounterId
                                                    }
                                                    value={
                                                        encounter?.patientEncounterId
                                                    }
                                                >
                                                    {`${encounter?.admissionDt
                                                        ? Utils.convertDate(
                                                            new Date(
                                                                encounter?.admissionDt
                                                            )
                                                        )
                                                        : ''
                                                        }${encounter?.admissionDt
                                                            ? ' - '
                                                            : ' '
                                                        }${encounter?.patientEncounterId}`}
                                                </MenuItem>
                                            )
                                        )}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>

                {selectedPatientEncounter && (
                    <div>
                        {financialClearanceStatusView}
                        {instanceOfCareOverview}
                        {isSelfPay
                            ? null
                            : doesInsuranceExist
                                ? insuranceView
                                : null}
                        {isSelfPay ? null : vobAccordion}
                        {/* {locAccordion} */}
                        {patientChampionsView}
                        {!isBillingEngineV3 && paymentProgramView}
                        {documentsView}
                        {(!isBillingEngineV3 && selectedPatientEncounter?.workflow?.workflowId === 3) &&
                            paymentStatusView}
                        {(isBillingEngineV3) &&
                            paymentStatusV2View}
                        {transactionsView}
                    </div>
                )}
            </Grid>
            <Grid item xs={4}>
                <Paper>
                    <div className="px-4 py-4">
                        <Comments page={commentsPage.patients} />
                    </div>
                </Paper>
            </Grid>
        </Grid>
    );

    return (
        <>
            {isLoadingEncounter || isLoadingVOB ? (
                <LoadingOverlay />
            ) : (
                <div className="icon-colors">
                    <Box
                        display="flex"
                        width={'100%'}
                        alignItems={'center'}
                        justifyContent={'flex-end'}
                        className="pb-4"
                    >
                        <AccessControl
                            rolePageName={RolePageNames.PatientRecords}
                            actionName="Add Instance of Care"
                            renderNoAccess={() => (
                                <Button disabled>Add Instance of Care</Button>
                            )}

                        >
                            <Button onClick={() => handleOpenIOCModal(false)} test-id="patient-drilldown-add-instance-of-care-button">
                                Add Instance Of Care

                            </Button>
                        </AccessControl>
                    </Box>
                    {!patientEncounters && showInstanceOfCareText}
                    {patientEncounters && instanceOfCareDetails}
                    {patientModalOpenStatus.isIOCModalOpen && (
                        <InstanceOfCareModal
                            open={patientModalOpenStatus.isIOCModalOpen}
                            isEdit={isIOCModalEditMode}
                            clientId={selectedPatientEncounter?.clientId}
                            handleModalCancel={handleIOCModalCancel}
                            handleModalSubmit={handleIOCModalSubmit}
                        />
                    )}
                    {isInsuranceModalOpen && (
                        <InsuranceModal
                            open={isInsuranceModalOpen}
                            handleModalClose={handleInsuranceModalClose}
                            isEdit={false}
                        />
                    )}
                    {isVobModalOpen && (
                        <FinpassVOBModal
                            open={isVobModalOpen}
                            isEdit={isIOCModalEditMode}
                            classifications={vobClassification}
                            facilityPayersState={facilityPayersState}
                            handleVOBModalCancel={handleVOBModalCancel}
                            handleVOBModalSubmit={handleVOBModalCancel}
                        />
                    )}
                    {/* {isLocModalOpen && (
                          <FinpassLevelOfCareModal
                              open={isLocModalOpen}
                              clientId={selectedPatientEncounter.clientId}
                              facilityId={selectedPatientEncounter.facilityId}
                              facilityName={facilities?.flat().find((el) => el.facilityId === selectedPatientEncounter.facilityId)?.facilityName}
                              quoteMethod={estimate?.quoteMethod ?? QuoteMethod.AVGLOS}
                              handleFinpassLevelOfCareModalClose={handleLocModalClose}
                              />
                    )} */}
                    {isChampionModalOpen && (
                        <ChampionModal
                            open={isChampionModalOpen}
                            handleModalClose={handleChampionModalClose}
                            championsIndex={
                                selectedPatientEncounter?.patientChampion
                                    ?.length
                                    ? selectedPatientEncounter.patientChampion
                                        .length
                                    : 0
                            }
                            isEdit={false}
                        />
                    )}
                    {isPaymentProgramsModalOpen && (
                        <PaymentProgramsModal
                            open={isPaymentProgramsModalOpen}
                            handleModalClose={handlePaymentProgramsModalClose}
                            isEdit={false}
                        />
                    )}
                    {isPaymentProgramsV2ModalOpen && (
                        <PaymentProgramsV2Modal
                            open={isPaymentProgramsV2ModalOpen}
                            handleModalClose={handlePaymentProgramsV2ModalClose}
                            isEdit={false}
                        />
                    )}
                    {isBalanceAdjustmentModalOpen && (
                        <BalanceAdjustmentModal
                            open={isBalanceAdjustmentModalOpen}
                            balanceAdjustmentModalValues={
                                balanceAdjustmentModalValues
                            }
                            handleModalClose={handleBalanceAdjustmentModalClose}
                            handleModalSave={handleBalanceAdjustmentModalSave}
                        />
                    )}
                    <BalanceAdjustmentConfirmationModal
                        open={isBalanceAdjustmentConfirmModalOpen}
                        balanceAdjustmentModalValues={
                            balanceAdjustmentModalValues
                        }
                        handleChangeBalanceAdjustment={
                            handleChangeBalanceAdjustment
                        }
                        handleConfirm={handleConfirmBalanceAdjustment}
                        isV2TxnTableEnabled={isV2TxnTableEnabled}
                        ledgerLimit={ledgerLimit}
                    />

                    {lockingModalOpenStatus.isInUseModalOpen_overview && (
                        <LockModal
                            open={
                                lockingModalOpenStatus.isInUseModalOpen_overview
                            }
                            title="Instance of Care In Use"
                            subTitle1={`A release request will be sent to ${selectedPatientEncounter.lockedByUserId}`}
                            subTitle2={`Access will be granted in ${countdownMax} seconds or less`}
                            hasCountdown={false}
                            countdownSeconds={countdownMax}
                            primaryButtonType="primary"
                            primaryButtonText="Request Release"
                            handlePrimaryButton={handleRequestReleaseOk}
                            secondaryButtonType="secondary"
                            secondaryButtonText="Cancel"
                            handleSecondaryButton={handleRequestReleaseCancel}
                            icon={<LockIcon />}
                            modalType="info"
                            justifyButtons="flex-end"
                            primaryButtonDisabled={
                                isRequestReleaseButtonDisabled
                            }
                        />
                    )}

                    {lockingModalOpenStatus.isRequestDeniedModalOpen_overview && (
                        <LockModal
                            open={
                                lockingModalOpenStatus.isRequestDeniedModalOpen_overview
                            }
                            title="Request Denied"
                            subTitle1={`${lockRequestedById} will retain access to this record`}
                            hasCountdown={false}
                            primaryButtonType="secondary"
                            primaryButtonText="Close"
                            handlePrimaryButton={handleRequestDeniedClose}
                            icon={<LockIcon />}
                            modalType="error"
                            justifyButtons="flex-end"
                        />
                    )}

                    {lockingModalOpenStatus.isLockRequestedModalOpen_overview && (
                        <LockModal
                            open={
                                lockingModalOpenStatus.isLockRequestedModalOpen_overview
                            }
                            title="Instance of Care Requested"
                            subTitle1={`${lockRequestedById} requested this record`}
                            subTitle2={`Access will be granted in ${countdownMax} seconds or less`}
                            hasCountdown
                            countdownSeconds={countdownMax}
                            primaryButtonType="primary"
                            primaryButtonText="Release Record"
                            handlePrimaryButton={handleReleaseRecordOk}
                            secondaryButtonType="danger"
                            secondaryButtonText="Deny Request"
                            handleSecondaryButton={() =>
                                dispatch(
                                    denyRequestOk({
                                        lockablePatientRecordSection:
                                            LockablePatientRecordSection.overview,
                                    })
                                )
                            }
                            icon={<WarningRoundedIcon />}
                            modalType="warning"
                            justifyButtons="space-between"
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default InstanceOfCare;
